export default () => ({
  value: "",

  containsContactDetails() {
    return this.value.includes("@") || /[\d -]{6,}/.test(this.value);
  },

  get errorMessage() {
    if (!this.containsContactDetails()) {
      return;
    }

    return "For the security of our community you cannot enter contact details. This includes websites and social media accounts. Don’t worry, it is FREE to send messages to others. If you want to be contacted via phone, make sure to allow access when verifying your phone number.";
  },
});
